// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3-y0U","validationTips":"StatementDescriptor_validationTips__buGq0"};